import { render, staticRenderFns } from "./creatVideoChannel.vue?vue&type=template&id=a3b66546&scoped=true"
import script from "./creatVideoChannel.vue?vue&type=script&lang=js"
export * from "./creatVideoChannel.vue?vue&type=script&lang=js"
import style0 from "./creatVideoChannel.vue?vue&type=style&index=0&id=a3b66546&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b66546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3b66546')) {
      api.createRecord('a3b66546', component.options)
    } else {
      api.reload('a3b66546', component.options)
    }
    module.hot.accept("./creatVideoChannel.vue?vue&type=template&id=a3b66546&scoped=true", function () {
      api.rerender('a3b66546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/videoChannel/draftList/creatVideoChannel.vue"
export default component.exports